import React, { useEffect, useRef, useState } from "react";
import "../assets/css/singleProductCard.css";
import { IoCall } from "react-icons/io5";
import CallbackModal from "./CallbackModal";
import { useParams } from "react-router-dom";
import axios from "axios";

function SingleProductCard() {
    const { id } = useParams();
    const [product, setProduct] = useState(null);
    const [open, setOpen] = useState(false);
    const [activeImage, setActiveImage] = useState("");
    const carouselRef = useRef(null);
    const [zoomOpen, setZoomOpen] = useState(false);

    const backendUrl = process.env.REACT_APP_BACKEND_URI;

    useEffect(() => {
        axios
            .get(`${backendUrl}/products/${id}`)
            .then((res) => {
                setProduct(res.data);
                console.log(product);


                // ✅ set first image safely
                if (Array.isArray(res.data.images) && res.data.images.length > 0) {
                    setActiveImage(res.data.images[0]);
                }
            })
            .catch((err) => console.error(err));
    }, [id, backendUrl]);

    const scrollUp = () => {
        carouselRef.current?.scrollBy({ top: -80, behavior: "smooth" });
    };

    const scrollDown = () => {
        carouselRef.current?.scrollBy({ top: 80, behavior: "smooth" });
    };

    if (!product) return <p>Loading...</p>;

    const images = Array.isArray(product.images) ? product.images : [];

    return (
        <div className="main-wrapper">
            <div className="product-container">
                <div className="product-header-bar">
                    <h1 className="product-title">{product.title}</h1>

                    <button className="animated-btn" onClick={() => setOpen(true)}>
                        <span className="btn-text-wrap">
                            <span className="btn-text">
                                <IoCall /> Request A Callback
                            </span>
                            <span className="btn-text btn-text-abs">
                                <IoCall /> Request A Callback
                            </span>
                        </span>
                    </button>
                </div>

                <div className="product-body">
                    <div className="product-image-wrapper">
                        {/* LEFT: Thumbnails */}
                        <div className="thumbnail-wrapper">
                            <button className="scroll-btn" onClick={scrollUp}>▲</button>

                            <div className="thumbnail-carousel" ref={carouselRef}>
                                {images.map((img, index) => (
                                    <div
                                        key={index}
                                        className={`thumbnail ${activeImage === img ? "active" : ""
                                            }`}
                                        onClick={() => setActiveImage(img)}
                                    >
                                        <img src={img} alt={product.title} />
                                    </div>
                                ))}
                            </div>

                            <button className="scroll-btn" onClick={scrollDown}>▼</button>
                        </div>

                        {/* RIGHT: Main Image */}
                        <div className="img-holder">
                            <img
                                src={activeImage || images[0]}
                                alt={product.title}
                                className="active-product-image"
                                onClick={() => setZoomOpen(true)}
                            />
                        </div>
                        {zoomOpen && (
                            <div className="image-zoom-overlay" onClick={() => setZoomOpen(false)}>
                                <div
                                    className="image-zoom-container"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <button
                                        className="zoom-close-btn"
                                        onClick={() => setZoomOpen(false)}
                                    >
                                        ✕
                                    </button>

                                    <img
                                        src={activeImage || images[0]}
                                        alt={product.title}
                                        className="zoomed-image"
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    <button
                        className="animated-btn"
                        onClick={() => setOpen(true)}
                        style={{ display: "block", margin: "20px auto 0" }}
                    >
                        <span className="btn-text-wrap">
                            <span className="btn-text">Yes! I'm Interested</span>
                            <span className="btn-text btn-text-abs">
                                Yes! I'm Interested
                            </span>
                        </span>
                    </button>

                    <h3 className="product-applications">Applications</h3>
                    <ul>
                        <li style={{ listStyle: 'disc', margin: '0 19px 0', lineHeight: '25px' }}>Various Moulding Compounds and Moulded Articles</li>
                        <li style={{ listStyle: 'disc', margin: '0 19px 0', lineHeight: '25px' }}>Bakelite</li>
                        <li style={{ listStyle: 'disc', margin: '0 19px 0', lineHeight: '25px' }}>Graphite & Carbon Articles Impregnation</li>
                        <li style={{ listStyle: 'disc', margin: '0 19px 0', lineHeight: '25px' }}>Cork Industry</li>
                        <li style={{ listStyle: 'disc', margin: '0 19px 0', lineHeight: '25px' }}>Graphite Moulding</li>
                        <li style={{ listStyle: 'disc', margin: '0 19px 0', lineHeight: '25px' }}>Lamp Capping Cement</li>
                        <li style={{ listStyle: 'disc', margin: '0 19px 0', lineHeight: '25px' }}>Water Proof Plywood / Compressed Wood / Particle Board</li>
                        <li style={{ listStyle: 'disc', margin: '0 19px 0', lineHeight: '25px' }}>Auto Filters</li>
                        <li style={{ listStyle: 'disc', margin: '0 19px 0', lineHeight: '25px' }}>Rubber Industries and Rice Dehusking Rubber Rollers</li>
                        <li style={{ listStyle: 'disc', margin: '0 19px 0', lineHeight: '25px' }}>Mineral Wool</li>
                        <li style={{ listStyle: 'disc', margin: '0 19px 0', lineHeight: '25px' }}>Brake and Clutch Liners</li>
                        <li style={{ listStyle: 'disc', margin: '0 19px 0', lineHeight: '25px' }}>Paper Cool Pads, Paper Tube</li>
                        <li style={{ listStyle: 'disc', margin: '0 19px 0', lineHeight: '25px' }}>Magnesia Carbon Refractory Bricks</li>
                        <li style={{ listStyle: 'disc', margin: '0 19px 0', lineHeight: '25px' }}>Grinding Wheels and Coated Abrasives</li>
                        <li style={{ listStyle: 'disc', margin: '0 19px 0', lineHeight: '25px' }}>Acid Resistant Resins</li>
                        <li style={{ listStyle: 'disc', margin: '0 19px 0', lineHeight: '25px' }}>Printing Inks</li>
                        <li style={{ listStyle: 'disc', margin: '0 19px 0', lineHeight: '25px' }}>Paper and Cloth Impregnation for Laminates</li>
                    </ul>

                    <h3 className="product-applications">Foundry Applications</h3>
                    <ul>
                        <li style={{ listStyle: 'disc', margin: '0 19px 0', lineHeight: '25px' }}>Coated Sand / Sleeves / Shell Joint</li>
                        <li style={{ listStyle: 'disc', margin: '0 19px 0', lineHeight: '25px' }}>Tundish Board etc.</li>
                        <li style={{ listStyle: 'disc', margin: '0 19px 0', lineHeight: '25px' }}>Moulded Articles</li>
                        <li style={{ listStyle: 'disc', margin: '0 19px 0', lineHeight: '25px' }}>Ester Cured Phenolic Resin System</li>
                    </ul>
                </div>
            </div>

            <CallbackModal
                product={product}
                isOpen={open}
                onClose={() => setOpen(false)}
            />
        </div>
    );
}

export default SingleProductCard;
